// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionDeckView
require("./styles/question-deck.css")

export default QuestionDeckView = (function () {
  QuestionDeckView = class QuestionDeckView extends (
    require("lib/static-shim").default(
      require("lib/core/composite-view").default
    )
  ) {
    static initClass() {
      this.prototype.template = require("./templates/question-deck.html")
      this.prototype.className = "question-deck-view"
      this.prototype.childView = require("./question-card").default
      this.prototype.childViewContainer = ".question-cards"

      this.prototype.modelEvents = { "assessment:reset": "onAssessmentReset" }

      this.prototype.childEvents = { "question:answered": "onQuestionAnswered" }
    }

    initialize() {
      return (this.collection = this.model.assessment.questions)
    }

    onQuestionAnswered(view, question, answer) {
      return this._detectCompletion()
    }

    onAssessmentReset() {
      this.initialize()
      return this.render()
    }

    onRender() {
      return this._detectCompletion()
    }

    _detectCompletion() {
      if (this.model.assessment.isCompleted()) {
        return this.triggerMethod("assessment:completed", this.model)
      }
    }

    childViewOptions(model, index) {
      return {
        assessment: this.model.assessment,
        isReview: this.model.get("isReview")
      }
    }
  }
  QuestionDeckView.initClass()
  return QuestionDeckView
})()
